import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getDoneWorksCalculationMaterialsMetrics(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,
		dtConfig[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].getDoneWorksCalculationMaterialsMetrics,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
			},
		},
	)
}
function getDoneWorksCalculationMaterialsMetricPreview(companyId, doneWorkId, calculationMaterialsMetricId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,
		dtConfig[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].getDoneWorksCalculationMaterialsMetricPreview,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				calculationMaterialsMetricId,
			},
		},
	)
}
function getDoneWorksCalculationMaterialsMetricPopup(companyId, doneWorkId, calculationMaterialsMetricId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,
		dtConfig[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].getDoneWorksCalculationMaterialsMetricPopup,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				calculationMaterialsMetricId,
			},
		},
	)
}

function createDoneWorksCalculationMaterialsMetric(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,dtConfig[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].createDoneWorksCalculationMaterialsMetric, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function getDoneWorksCalculationMaterialsMetric(companyId, doneWorkId, calculationMaterialsMetricId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,dtConfig[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].getDoneWorksCalculationMaterialsMetric, {
		urlParams: {
			companyId,
			doneWorkId,
			calculationMaterialsMetricId,
		},
	})
}

function patchDoneWorksCalculationMaterialsMetric(companyId, doneWorkId, calculationMaterialsMetricId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,dtConfig[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].patchDoneWorksCalculationMaterialsMetric, {
		urlParams: {
			companyId,
			doneWorkId,
			calculationMaterialsMetricId,
		},
		...data,
	})
}

function patchDoneWorksCalculationMaterialsMetricBulkUpdate(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,dtConfig[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].patchDoneWorksCalculationMaterialsMetricBulkUpdate, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function putDoneWorksCalculationMaterialsMetric(companyId, doneWorkId, calculationMaterialsMetricId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,dtConfig[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].putDoneWorksCalculationMaterialsMetric, {
		urlParams: {
			companyId,
			doneWorkId,
			calculationMaterialsMetricId,
		},
		...data,
	})
}

function deleteDoneWorksCalculationMaterialsMetric(companyId, doneWorkId, calculationMaterialsMetricId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,dtConfig[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].deleteDoneWorksCalculationMaterialsMetric, {
		urlParams: {
			companyId,
			doneWorkId,
			calculationMaterialsMetricId,
		},
	})
}

export default {
	getDoneWorksCalculationMaterialsMetrics,
	getDoneWorksCalculationMaterialsMetricPopup,
	getDoneWorksCalculationMaterialsMetricPreview,
	getDoneWorksCalculationMaterialsMetric,
	patchDoneWorksCalculationMaterialsMetric,
	putDoneWorksCalculationMaterialsMetric,
	createDoneWorksCalculationMaterialsMetric,
	deleteDoneWorksCalculationMaterialsMetric,
	patchDoneWorksCalculationMaterialsMetricBulkUpdate,
}
